import AssistantAndMaster from "../../assets/imgs/128.gif";
import BattleMaster from "../../assets/imgs/32.gif";

export const checkGuildType = (type) => {
  switch (type) {
    case 0:
      return "Guild Member";
    case 64:
      return (
        <div>
          Assistant Master &nbsp;
          <img src={AssistantAndMaster} alt="" />
        </div>
      );

    case 32:
      return (
        <div>
          Battle Master &nbsp;
          <img
            style={{ width: "20px", height: "20px" }}
            src={BattleMaster}
            alt=""
          />
        </div>
      );

    case 128:
      return (
        <div>
          Guild Master &nbsp;
          <img src={AssistantAndMaster} alt="" />
        </div>
      );
    // default:
    // return "N/A";
  }
};
